import styled from "styled-components";
import { ExternalLink } from "@pepdirect/v3/ui/ExternalLink";

export const StyledOuterWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const StyledInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px;
`;

export const StyledText = styled.div`
  font-size: 15px;
  line-height: 23px;
`;

export const StyledExternalLink = styled(ExternalLink)`
  margin: auto;
`;
